import { hasPermission, homeForRole, type Permission } from './access'

declare module 'vue-router' {
  interface RouteMeta {
    requiresAuth?: boolean
    permission?: Permission
  }
}

/** Pure and bounded: unauthorized targets never redirect to themselves. */
export function accessRedirect(
  target: { name?: unknown; meta: { requiresAuth?: boolean; permission?: Permission } },
  session: { loggedIn: boolean; role: unknown },
): string | null {
  if (target.meta.requiresAuth === false) return null
  if (!session.loggedIn) return 'Login'
  if (!target.meta.permission || hasPermission(session.role, target.meta.permission)) return null
  const destination = homeForRole(session.role).name
  return destination === target.name ? 'Login' : destination
}
